<template>
  <div class="text-h5">
    <div class="d-flex flex-start">
      <div
        v-if="number && number.length > 0"
        class="mr-3"
      >
        {{ number }}
      </div>
      <survey-question-text :text="text"></survey-question-text>
    </div>
  </div>
</template>

<script>
import SurveyQuestionText from "./Survey.Question.Text.vue"

export default {
  name: "QuestionReportLabel",
  components: { SurveyQuestionText },
  props: ["number", "text"],
};
</script>